var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupMenuDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8889 0.888672V3.77757M5.11108 0.888672V3.77757",
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8889 0.888672V3.77757M5.11108 0.888672V3.77757",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72225 2.33398H7.2778C4.55412 2.33398 3.19228 2.33398 2.34614 3.18012C1.5 4.02627 1.5 5.3881 1.5 8.11179V9.55624C1.5 12.2799 1.5 13.6418 2.34614 14.4879C3.19228 15.334 4.55412 15.334 7.2778 15.334H8.72225C11.4459 15.334 12.8078 15.334 13.6539 14.4879C14.5001 13.6418 14.5001 12.2799 14.5001 9.55624V8.11179C14.5001 5.3881 14.5001 4.02627 13.6539 3.18012C12.8078 2.33398 11.4459 2.33398 8.72225 2.33398Z",
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72225 2.33398H7.2778C4.55412 2.33398 3.19228 2.33398 2.34614 3.18012C1.5 4.02627 1.5 5.3881 1.5 8.11179V9.55624C1.5 12.2799 1.5 13.6418 2.34614 14.4879C3.19228 15.334 4.55412 15.334 7.2778 15.334H8.72225C11.4459 15.334 12.8078 15.334 13.6539 14.4879C14.5001 13.6418 14.5001 12.2799 14.5001 9.55624V8.11179C14.5001 5.3881 14.5001 4.02627 13.6539 3.18012C12.8078 2.33398 11.4459 2.33398 8.72225 2.33398Z",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.66797H14.5001",
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.66797H14.5001",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99673 9.55469H8.00324M7.99673 12.4436H8.00324M10.8824 9.55469H10.8889M5.11108 9.55469H5.11756M5.11108 12.4436H5.11756",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99673 9.55469H8.00324M7.99673 12.4436H8.00324M10.8824 9.55469H10.8889M5.11108 9.55469H5.11756M5.11108 12.4436H5.11756",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMenuDetails);
export default __webpack_public_path__ + "static/media/group_menu_details.c53cddfce670cbb6fc551c6999547830.svg";
export { ForwardRef as ReactComponent };